export default defineNuxtPlugin((nuxtApp) => {
  if (nuxtApp.$api) {
    nuxtApp.$api.defaults.withCredentials = true
    nuxtApp.$api.defaults.xsrfCookieName = 'XSRF-TOKEN'
    nuxtApp.$api.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'
  }
})
